import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { fetchUser } from '../actions/users';
import { fetchPromoter, fetchPromoterFormations } from '../actions/promoters';
import { NotebookTabs } from 'lucide-react'
import '../styles/TrainingView.css'
import FormationCard from '../components/FormationCard'
import TrainingPageHeader from '../components/TrainingPageHeader';
import { API_ROOT } from '../config';
class TrainingView extends React.Component {
  constructor(props) {
    super(props)
    this.state = { adminFormations: null };
  }
  async componentDidMount() {
    const userId = this.props.match.params.id;
    this.props.fetchUser(userId);
    if (this.props.role !== 'ADMIN') this.props.fetchPromoter(userId);

    if (this.props.role === 'ADMIN') {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_ROOT}formations`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        const mapped = data.map(f => ({
          formation: f,
          blocks: f.blocks.map(b => ({ block: b._id, approved: false })),
          approved: false,
        }));
        this.setState({ adminFormations: mapped });
      }
    } else {
      this.props.fetchPromoterFormations(userId);
    }
  }
  notaMedia = () => {
    const formations = this.props.promoterFormations;
    if (!formations || formations.length === 0) return 'N/A';
    const blocks = formations.flatMap(f =>
      (f.blocks || []).filter(bp => {
        const def = (f.formation?.blocks || []).find(b => b._id === bp.block);
        return def?.mode === 'test' && bp.score != null;
      })
    );
    if (blocks.length === 0) return 'Sin datos';
    const avg = blocks.reduce((sum, b) => sum + b.score, 0) / blocks.length;
    return `${Math.ceil(avg / 10)}/10`;
  }
  modulosHechos = () => {
    const formations = this.props.promoterFormations;
    if(!formations || formations.length === 0) return 'Ninguna formación asignada';
    const bloquesTotales = formations.reduce((sum, f) => sum + (f.blocks ? f.blocks.length : 0), 0);
    const bloquesHechos = formations.reduce((sum, f) => sum + (f.blocks ? f.blocks.filter(b => b.approved).length : 0), 0);
    if(bloquesHechos === 0) return 'Ninguna formación iniciada';
    const porcentaje = Math.round((bloquesHechos / bloquesTotales) * 100);
    return `${porcentaje}%`;
  }
  render() {
    const { promoter, promoterFormations, role } = this.props;
    const isAdmin = role === 'ADMIN';

    const formations = this.state.adminFormations || promoterFormations || [];
    const total      = formations.length;
    const completed  = formations.filter(f => f.approved).length;
    const pending    = total - completed;
    const progress   = total > 0 ? Math.round((completed / total) * 100) : 0;

    const sortedFormations = [...formations].sort((a, b) => (a.formation?.order ?? Infinity) - (b.formation?.order ?? Infinity));

    return (
      <div>
        <TrainingPageHeader icon={<NotebookTabs size={30} />} title="Training" />
        {/* Resumen */}
        <div className="training-row mb-3">
          <div className="training-card training-accent-total">
            <div className="training-card-inner">
              <div className="d-flex align-items-center gap-2">
                <div className="training-card-icon"><i className="fas fa-book-open" /></div>
                <div className="training-card-title">Pendientes</div>
              </div>
              {pending === 0 ? (
                <div className="text-success fw-semibold mt-2">¡Todas las formaciones completadas!</div>
              ) : (
                <>
                  <div className="small text-muted mt-2">{completed} de {total} formaciones completadas</div>
                  <div className="progress mt-2" style={{ height: 10, borderRadius: 6 }}>
                    <div
                      className="progress-bar bg-success"
                      role="progressbar"
                      style={{ width: `${progress}%`, borderRadius: 6 }}
                      aria-valuenow={progress}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    />
                  </div>
                  <div className="small text-muted mt-1">{progress}% completado</div>
                </>
              )}
            </div>
          </div>
          <div className="training-card training-accent-total">
            <div className="training-card-inner">
              <div className="d-flex align-items-center gap-2">
                <div className="training-card-icon"><i className="fas fa-check-circle" /></div>
                <div className="training-card-title">Nota media</div>
              </div>
              <div className="training-value">{this.notaMedia()}</div>
              <div className="small text-muted" style={{ marginTop: 2 }}>de {total} formaciones</div>
            </div>
          </div>

          <div className="training-card training-accent-occupancy">
            <div className="training-card-inner">
              <div className="d-flex align-items-center gap-2">
                <div className="training-card-icon"><i className="fas fa-signal" /></div>
                <div className="training-card-title">Modulos hechos</div>
              </div>
              <div className="training-value">{this.modulosHechos()}</div>
              <div className="small text-muted" style={{ marginTop: 2 }}></div>
            </div>
          </div>

          </div>
           <div className="training-card training-accent-info">
            <div className="training-card-inner">
              <div className="d-flex align-items-center gap-2">
                <div className="training-card-icon"><i className="fas fa-circle-info" /></div>
                <div className="training-card-title">¿Cómo superar las formaciones?</div>
              </div>
              <ul className="small text-muted mb-0 mt-2 ps-3" style={{ textAlign:'start' }}>
                <li>Completa <strong>todas las secciones</strong> de cada bloque en orden.</li>
                <li>Para acceder al <strong>examen</strong> debes haber superado el bloque anterior.</li>
                <li>Aprueba todos los bloques para completar la formación.</li>
              </ul>
            </div>
          
        </div>

        {/* Lista de formaciones */}
        <div className='training-list-container p-3 bg-white rounded shadow-sm'>
        <div className="training-list-section ">
          {formations.length === 0 && (
            <div className="text-muted text-center py-4">No hay formaciones asignadas.</div>
          )}
          {sortedFormations.map((entry, fIdx) => {
              const blockProgressMap = {};
              (entry.blocks || []).forEach(bp => {
                blockProgressMap[bp.block] = bp;
              });

              const f = entry.formation;
              const sortedBlocks = [...(f.blocks || [])].sort((a, b) => a.order - b.order);
              const totalBlocks = (f.blocks || []).length;
              const doneBlocks = (entry.blocks || []).filter(b => b.approved).length;
              const fProgress = totalBlocks > 0 ? Math.round((doneBlocks / totalBlocks) * 100) : 0;
              const status = entry.approved ? 'success' : fProgress > 0 ? 'neutral' : 'danger';
              const prevEntry = fIdx > 0 ? sortedFormations[fIdx - 1] : null;
              const isFormationLocked = !isAdmin && prevEntry != null && f.order != null && !prevEntry.approved;

              return (
                <FormationCard
                  key={f._id}
                  title={f.name}
                  value={`${doneBlocks}/${totalBlocks}`}
                  icon={f.mandatory ? 'fa-star' : 'fa-book'}
                  portrait={f.portrait || null}
                  accent="total"
                  status={status}
                  progress={fProgress}
                  isLocked={isFormationLocked}
                  options={sortedBlocks.map((b, idx) => {
                    const prevBlock = idx > 0 ? sortedBlocks[idx - 1] : null;
                    const isLocked = !isAdmin && prevBlock && !blockProgressMap[prevBlock._id]?.approved;
                    const bProgress = blockProgressMap[b._id];
                    const blockStatus = isLocked ? 'locked' : bProgress?.approved ? 'done' : 'pending';
                    return {
                      label: b.name,
                      icon: b.mode === 'test' ? 'fa-pen-to-square' : 'fa-book-open',
                      status: blockStatus,
                      onClick: isLocked ? undefined : () => {
                        const userId = this.props.match.params.id;
                        const dest = b.mode === 'test'
                          ? `/training/${userId}/${f.slug}/${b._id}/test`
                          : `/training/${userId}/${f.slug}/${b._id}/text`;
                        this.props.history.push(dest);
                      },
                    };
                  })}
                />
              );
            })}
        </div>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    user: state.users.user,
    error: state.users.error,
    promoter: state.promoters.promoter,
    promoterFormations: state.promoters.promoterFormations,
    promoterError: state.promoters.error,
    role: state.auth.role,
  }),
  dispatch => ({
    fetchUser: bindActionCreators(fetchUser, dispatch),
    fetchPromoter: bindActionCreators(fetchPromoter, dispatch),
    fetchPromoterFormations: bindActionCreators(fetchPromoterFormations, dispatch),
  })
)(TrainingView)